












import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AppTextarea from '@/components/AppTextarea.vue'
import { IEndorsementNoteInput } from '@/modules/Policy/interfaces/policy-form'

@Component({
  components: {
    AppTextarea
  }
})
export default class EndorsementFormNote extends Vue {
  @Prop({ type: Object as () => IEndorsementNoteInput }) value!: IEndorsementNoteInput

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
